// extracted by mini-css-extract-plugin
export default {"editPart":"styles_editPart__hRHLY","editPart-form_container":"styles_editPart-form_container__0gcN5","editPart-btnContainer":"styles_editPart-btnContainer__RCy5S"};